(function(){
  function setAll(id, text){
    var els=document.querySelectorAll('[id="'+id+'"]');
    for(var i=0;i<els.length;i++){els[i].textContent=text;}
    return els.length;
  }

  function startTimer(key, hId, mId, sId) {
    var stored; try{stored=localStorage.getItem(key);}catch(e){}
    var end;
    if(!stored||Number(stored)<Date.now()){end=Date.now()+4*3600000;try{localStorage.setItem(key,end);}catch(e){}}
    else{end=Number(stored);}
    function tick(){
      var found=document.querySelectorAll('[id="'+hId+'"]').length;
      if(!found){setTimeout(tick,300);return;}
      var diff=Math.max(0,Math.floor((end-Date.now())/1000));
      setAll(hId,String(Math.floor(diff/3600)).padStart(2,'0'));
      setAll(mId,String(Math.floor((diff%3600)/60)).padStart(2,'0'));
      setAll(sId,String(diff%60).padStart(2,'0'));
      if(diff>0){setTimeout(tick,1000);}
      else{end=Date.now()+4*3600000;try{localStorage.setItem(key,end);}catch(e){}setTimeout(tick,1000);}
    }
    tick();
  }

  function startTimerWithDays(key, dId, hId, mId, sId, durationMs) {
    var stored; try{stored=localStorage.getItem(key);}catch(e){}
    var end;
    if(!stored||Number(stored)<Date.now()){end=Date.now()+durationMs;try{localStorage.setItem(key,end);}catch(e){}}
    else{end=Number(stored);}
    function tick(){
      var found=document.querySelectorAll('[id="'+dId+'"]').length;
      if(!found){setTimeout(tick,300);return;}
      var diff=Math.max(0,Math.floor((end-Date.now())/1000));
      setAll(dId,String(Math.floor(diff/86400)).padStart(2,'0'));
      setAll(hId,String(Math.floor((diff%86400)/3600)).padStart(2,'0'));
      setAll(mId,String(Math.floor((diff%3600)/60)).padStart(2,'0'));
      setAll(sId,String(diff%60).padStart(2,'0'));
      if(diff>0){setTimeout(tick,1000);}
      else{end=Date.now()+durationMs;try{localStorage.setItem(key,end);}catch(e){}setTimeout(tick,1000);}
    }
    tick();
  }

  startTimer('vgr395e','vgr-h','vgr-m','vgr-s');
  startTimer('dsp60174e','dsp-h','dsp-m','dsp-s');
  startTimer('kamera582e','kamera-h','kamera-m','kamera-s');
  startTimer('igraonica471e','igraonica-h','igraonica-m','igraonica-s');
  startTimer('aquablast829e','aqua-h','aqua-m','aqua-s');
  startTimerWithDays('kmp_lampa_v1','kmp-d','kmp-h','kmp-m','kmp-s',(2*24+6)*3600000);
  startTimerWithDays('aircool_v1','acl-d','acl-h','acl-m','acl-s',(2*24+4)*3600000);
  startTimerWithDays('sld_sladoled_v1','sld-d','sld-h','sld-m','sld-s',(2*24+6)*3600000);

  var osobe=[
    ['Marko','M','m'],['Stefan','S','m'],['Nikola','N','m'],['Aleksa','A','m'],
    ['Milan','M','m'],['Petar','P','m'],['Lazar','L','m'],['Dragan','D','m'],
    ['Ivan','I','m'],['Bojan','B','m'],['Dejan','D','m'],['Nemanja','N','m'],
    ['Milos','M','m'],['Vladimir','V','m'],['Djordje','D','m'],
    ['Jovana','J','z'],['Ana','A','z'],['Milica','M','z'],['Tamara','T','z'],
    ['Jelena','J','z'],['Ivana','I','z'],['Marija','M','z'],['Dragana','D','z'],
    ['Natasa','N','z'],['Vesna','V','z']
  ];
  var gradovi=['Beograd','Novi Sad','Nis','Kragujevac','Subotica','Zrenjanin','Pancevo','Cacak','Leskovac','Sabac','Pozarevac','Smederevo','Valjevo','Uzice'];
  var muBoje=['#1565C0','#2E7D32','#4527A0','#00695C','#283593','#0277BD'];
  var zeBoje=['#AD1457','#C62828','#880E4F','#00838F','#E65100','#6A1B9A'];
  var isVGR=window.location.pathname.indexOf('vgr')>-1;
  var isDSP=window.location.pathname.indexOf('dsp')>-1;
  var isKamera=window.location.pathname.indexOf('kamera')>-1;
  var isIgraonica=window.location.pathname.indexOf('igraonica')>-1;
  var isAquablast=window.location.pathname.indexOf('aquablast')>-1;
  var isLampa=window.location.pathname.indexOf('lampa')>-1;
  var isAircool=window.location.pathname.indexOf('aircool')>-1;
  var isSladoled=window.location.pathname.indexOf('sladoled')>-1;

  function showPopup(){
    var popup=document.getElementById('kupbre-popup');
    var txt=document.getElementById('popup-text');
    var av=document.getElementById('popup-avatar');
    if(!popup||!txt||!av){
      popup=document.getElementById('vgr-popup');
      txt=document.getElementById('vgr-txt');
      av=document.getElementById('vgr-av');
    }
    if(!popup||!txt||!av)return;
    var idx=Math.floor(Math.random()*osobe.length);
    var osoba=osobe[idx];
    if(osoba[2]==='z'&&Math.random()>0.35){
      var muske=osobe.filter(function(o){return o[2]==='m';});
      osoba=muske[Math.floor(Math.random()*muske.length)];
    }
    var grad=gradovi[Math.floor(Math.random()*gradovi.length)];
    var isMusko=osoba[2]==='m';
    var boja=(isMusko?muBoje:zeBoje)[Math.floor(Math.random()*(isMusko?muBoje:zeBoje).length)];
    var glagol=isMusko?'naručio':'naručila';
    var proizvod=isDSP?'DSP 8D Brijač':(isVGR?'VGR V-395':(isKamera?'Sigurnosnu kameru':(isIgraonica?'3u1 Šator za decu':(isAquablast?'AquaBlast Pro':(isLampa?'UV Lampu za komarce':(isAircool?'AirCool Mini Klimu':(isSladoled?'Aparat za voćni sladoled':'proizvod')))))));
    txt.textContent=osoba[0]+' iz '+grad+' '+glagol+' '+proizvod;
    if(av.tagName==='IMG'){av.src='https://ui-avatars.com/api/?name='+osoba[0]+'&background='+boja.replace('#','')+'&color=fff&size=40';}
    else{av.textContent=osoba[1];av.style.background=boja;}
    popup.style.cssText='display:block;position:fixed;bottom:24px;left:24px;z-index:99999;max-width:290px;background:white;border-radius:12px;padding:12px 14px;box-shadow:0 8px 32px rgba(0,0,0,0.15);border-left:4px solid '+boja+';opacity:0;transform:translateY(16px);transition:opacity 0.35s,transform 0.35s;';
    setTimeout(function(){popup.style.opacity='1';popup.style.transform='translateY(0)';},10);
    setTimeout(function(){
      popup.style.opacity='0';popup.style.transform='translateY(16px)';
      setTimeout(function(){popup.style.display='none';},350);
    },4500);
    setTimeout(showPopup,Math.floor(Math.random()*18000)+10000);
  }
  if(isVGR||isDSP||isKamera||isIgraonica||isLampa||isAircool||isSladoled){setTimeout(showPopup,Math.floor(Math.random()*7000)+4000);}
})();
